import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Zendesk Create Ticket v2 Configuration Validator
 * Validates Zendesk ticket creation configuration with followers support
 */
const zendeskFollowerSchema = z
    .object({
    user_id: z.string().optional(),
    user_email: z.string().email().optional()
})
    .refine((data) => data.user_id || data.user_email, {
    message: 'Either User ID or User Email must be provided'
});
export const Zendesk_Create_Ticket_2_ConfigValidator = z.object({
    zendeskConnection: requiredString('Zendesk Connection is required'),
    subject: requiredString('Ticket Subject is required'),
    description: requiredString('Ticket Description is required'),
    requesterName: z.string().optional(),
    requesterEmail: z.string().optional(),
    brandId: z.string().optional(),
    assigneeId: z.string().optional(),
    groupId: z.string().optional(),
    ticketFormId: z.string().optional(),
    status: z.enum(['new', 'open', 'pending', 'hold', 'solved', 'closed']).nullable().optional(),
    customFields: z.record(z.string(), z.any()).optional(),
    followers: z.array(zendeskFollowerSchema).optional()
});
//# sourceMappingURL=zendesk-create-ticket-2.js.map